import { getSettlement, postTaxPdf } from "crud/auth.crud";
import React, { useState, useEffect, Fragment } from "react"
import axios from "axios";

import { Link, useLocation } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"
import { useSelector } from "react-redux";

import moment from "moment";
import Util from "pages/Dashboard/Common/Util";
import loading from "../../assets/images/loading.gif";
import Modal from "components/RopikCustom/Modal_v2";
import Pagination from "pages/Custom/Pagination";
import $ from 'jquery';
import { getWasteCollect } from "crud/collect.crud";


const CollectionSettlementTable = ({listCount, setListCount}) => {
  const selector = useSelector(state => state)
  const location = useLocation()

  const [dataList, setDataList] = useState([])
  const [detailDataList, setDetailDataList] = useState([])
  const [modalShow, setModalShow] = useState({
    detail: false,
    edit: false,
    deactivate: false
  })
  const [selectedId, setSelectedId] = useState([])
  const [detailData, setDetailData] = useState(null)
  const [page, setPage] = useState(1)
  const [isLoading, setIsLoading] = useState(false);
  const [pagesGroup, setPagesGroup] = useState(1);  
  const [contentCount, setContentCount] = useState();  
  const [memo, setMemo] = useState('')
  const [selectedItem, setSelectedItem] = useState(null)
  const [isListEnd, setIsListEnd] = useState(false);
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    const scBody = document.getElementById("sc-body");
    if (!scBody) return;
    const handleScroll = () => {
      const scrollPosition = scBody.scrollTop;
      const scrollHeight = scBody.scrollHeight - scBody.clientHeight;
      if (scrollPosition >= scrollHeight - 1) {
        getDataList();
      }
    }
    scBody.addEventListener('scroll', handleScroll)

    return () => {
      scBody.removeEventListener('scroll', handleScroll)
    }
  }, [dataList, isFetching, isListEnd, page])

  const checkList = (id) => {
    setSelectedId(prev =>
      prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
    )
  }
  
  const checkAll = () => {    
    if (selectedId.length === detailDataList.length) {
      setSelectedId([])
    } else {
      setSelectedId(detailDataList.map(i => i.id))
    }
  }

  const deleteSettlement = async() => {
    
  }

  const getWasteCollectData = async (item)=>{
      const params = {      
        company: item.company?.id,
        startDate : moment(item?.summary_date).clone().subtract(1, 'month').format('YYYY-MM-DD'),
        endDate : moment(item?.summary_date).format('YYYY-MM-DD'),
      }
     const response = await getWasteCollect(params);    
    if (response.status === 200) {
        const content = response.data?.data || [];        
        setDetailDataList([...content])                            
      }
     
  }

  const openDetailModal = (item) => {
    getWasteCollectData(item)
    setDetailData(item);
    modalOpen('edit');    
  }

  const getDataList = async () => {
    if (isFetching || isListEnd) {              
      return;
    }
    setIsLoading(true)
    setIsFetching(true)
    try{
      const params = {
        page: page,
        company: location.state?.company?.id,
        collection_company: selector.auth?.user?.member_group?.[0]?.company_group?.id
      }

      let url = '/summary_waste_collect/data_list/?page=' + params.page + '&company=' + params.company + '&collection_company=' + params.collection_company;

      const response = await getSettlement(url);      
      if (response.status === 200) {
        const content = response.data?.results || [];
        if (content.length > 0) {
          setDataList([...dataList, ...content])
          setListCount(response.data?.count || 0)
          setPage(page + 1)
        }else{
          setIsListEnd(true)
        }
      }
    }catch{
      setIsListEnd(true)
    }
    
    setIsFetching(false)
    setIsLoading(false)
  }

  const modalOpen = (key) => {
    setModalShow(prev => ({...prev, [key]: true}))
  }

  const modalClose = (key) => {
    setModalShow(prev => ({...prev, [key]: false}))
  }

  const fileDownload = async (item) => {
    const cdnhost = 'https://waveradmin.ropiklabs.com'

    let start_date = moment(item?.summary_date).subtract(1, 'months').format('YYYY-MM-DD')
    let end_date = moment(item?.summary_date).format('YYYY-MM-DD')
    if(moment(item?.summary_date).format('DD') == '01'){
      start_date = moment(item?.summary_date).format('YYYY-MM-DD')
      end_date = moment(item?.summary_date).add(1, 'months').format('YYYY-MM-DD')
    }

    const params = {
      company: location.state?.company?.id,
      company_name: location.state?.company?.name,
      price: item?.total_price,
      ym: moment(item?.summary_date).format('YYYY-MM'),
      start_date: start_date,
      end_date: end_date
    }
    let url = (cdnhost + '/api/v1/summary_waste_collect/download_collect_excel/?company=' + params.company + '&company_name=' + params.company_name + '&price=' + params.price + '&ym=' + params.ym + '&start_date=' + params.start_date + '&end_date=' + params.end_date)
    const rs = await axios.get(url)
    if(rs.data?.result == 'success'){
      fetch(cdnhost + '/media/excel/' + params.company + '/' + params.ym + '-관리대장.xlsx')
        .then((response) => response.blob())
        .then((blob) => {
          const excelUrl = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href = excelUrl;
          link.setAttribute('download', `${moment(item?.summary_date).format('YYYY-MM')}_관리대장.xlsx`);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          console.error(error)
        })
    }
  };

  useEffect(() => {
    getDataList()
  }, [page])

  return (
    <Fragment>
      <div className="email-rightbar mb-3">
        <Card>
          <CardBody style={{ padding: 0, borderRadius: 4, overflowX: 'hidden', overflowY: 'hidden', height: 806 }}>
            <div className="table-responsive" id={"sc-body"} style={{maxHeight: 660, padding: 0, overflowX: 'hidden', overflowY: 'auto', height: 806 }}>
              <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
                <thead className="chart-thead">
                  <tr>
                    <th scope="col">No</th>
                    <th scope="col">정산년월</th>
                    <th scope="col">정산일자</th>
                    <th scope="col">납부일자</th>
                    <th scope="col">수거량</th>
                    <th scope="col">정산금액(원)</th>
                    <th scope="col">납부여부</th>
                    <th scope="col">보고서</th>
                    {/* <th scope="col">수정</th> */}
                  </tr>
                </thead>
                <tbody className="chart-tbody clickable">

                  {dataList.map((item, index) => {
                    return (
                      <tr className="pointer" key={item.id + '_' + index} >                        
                        <td className="pointer" onClick={() => { openDetailModal(item) }}>{listCount - index}</td>
                        <td className="pointer" onClick={() => { openDetailModal(item) }} >{moment(item.summary_date).format('YYYY-MM') || ''}</td>
                        <td className="pointer" onClick={() => { openDetailModal(item) }} >{moment(item.summary_date).format('YYYY-MM-DD') || ''}</td>
                        <td className="pointer" onClick={() => { openDetailModal(item) }} >{item.payment_date ? moment(item.payment_date).format('YYYY-MM-DD') : ''}</td>
                        <td className="pointer" onClick={() => { openDetailModal(item) }} >{Util.setCommaPrice((item.contract?.collect_type == 'l' ? item?.qty_l : item?.qty_kg) || 0)}</td>
                        <td className="pointer" onClick={() => { openDetailModal(item) }} >{Util.setCommaPrice(item.total_price || 0)}</td>
                        <td>{item.state === 'Y' ? '완납' : item.state === 'N' ? '미납' : '부분납부'}</td>                        
                        <td className="click-not">
                          <button style={{ width: 83, height: 29 }} type="button" className="custom-btn border-radius-0 font-size-15 line-height-1 button-border secondary-text white-bg margin-right-0" onClick={(e) => {                            
                            fileDownload(item)
                          }}>
                            다운로드
                          </button>
                        </td>
                        {/* 
                        <td className="click-not">
                          <button style={{ width: 83, height: 29 }} type="button" className="custom-btn border-radius-0 font-size-15 line-height-1 primary-bg white-text button-border margin-right-0" onClick={(e) => {
                            setSelectedItem(item);
                            modalOpen('edit');
                          }}>
                            수정
                          </button>
                        </td> 
                        */}
                      </tr>
                    )
                  })}
                  {dataList.lenght === 0 &&
                    <tr>
                      <td scope="row" colSpan="6">데이터가 없습니다.</td>
                    </tr>
                  }

                </tbody>
              </table>
            </div>
          </CardBody>
          {isLoading && <div style={{
            position: "absolute",
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            background: 'rgba(255, 255, 255, 0.6)',
            zIndex: 999,
            display: "flex",
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <img src={loading} alt="로딩중입니다." width={'7%'}></img>
          </div>}
        </Card>
        
      </div>

      <Modal title={'정산 상세 내역'} show={modalShow.detail} onHide={modalClose} size="md"
      bodyChildren={
        <Fragment>
        <table className="input-table">
          <tbody>
            <tr>
              <td className="w-20 padding-left-8 primary-bg white-text font-size-12">업체명</td>
              <td className="w-80">{detailData?.company.name}</td>
            </tr>
            <tr>
              <td className="w-20 padding-left-8 primary-bg white-text font-size-12">수거량(ℓ)</td>
              <td className="w-80 text-end">{Util.setCommaPrice(detailData?.qty_l)}</td>
            </tr>
            <tr>
              <td className="w-20 padding-left-8 primary-bg white-text font-size-12">정산금액</td>
              <td className="w-80 text-end">{Util.setCommaPrice(detailData?.price)}</td>
            </tr>
            <tr>
              <td className="w-20 padding-left-8 primary-bg white-text font-size-12">부가세(VAT)</td>
              <td className="w-80 text-end">{Util.setCommaPrice(detailData?.vat)}</td>
            </tr>
            <tr>
              <td className="w-20 padding-left-8 primary-bg white-text font-size-12">고지금액</td>
              <td className="w-80 text-end">{Util.setCommaPrice(detailData?.total_price)}</td>
            </tr>
            <tr>
              <td className="w-20 padding-left-8 primary-bg white-text font-size-12">납부금액</td>
              <td className="w-80 text-end">{Util.setCommaPrice(detailData?.payed_price)}</td>
            </tr>
            <tr>
              <td className="w-20 padding-left-8 primary-bg white-text font-size-12">미납금액</td>
              <td className="w-80 text-end">{Util.setCommaPrice(detailData?.total_price - detailData?.payed_price)}</td>
            </tr>
            <tr>
              <td className="w-20 padding-left-8 primary-bg white-text font-size-12">완납여부</td>
              <td className="w-80 text-end">{detailData?.state === 'Y' ? '완납' : detailData?.state === 'N' ? '미납' : '부분납부'}</td>
            </tr>
          </tbody>
        </table>
        </Fragment>
        }
        footerChildren={
        <div className="d-flex justify-content-between w-100">
          <button style={{width: 112, height: 27}} className="`custom-btn border-radius-0 margin-right-4 font-size-11 line-height-1 success-bg white-text border-none" onClick={() => {
            fileDownload(detailData)
          }}>엑셀 다운로드</button>
          <button style={{width: 59, height: 27}} className="custom-btn border-radius-0 font-size-11 line-height-1 button-border secondary-text white-bg margin-right-0" onClick={() => {
            setDetailData(null)
            modalClose('detail')
          }}>확인</button>
        </div>
        }
      />

      <Modal
        title={'정산 상세 내역'}
        show={modalShow.edit}
        onHide={() => {
          modalClose('edit')
          setSelectedItem(null)
        }}
        size="lg"
        bodyChildren={
          <Fragment>
            <table className="input-table">
              <tbody>
                <tr>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">정산년월</td>                  
                  <td className="w-35">{detailData?.summary_date ? moment(detailData?.summary_date).format('YYYY-MM') : ''}</td>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">총 수거량(ℓ)</td>
                  <td className="w-35">{Util.setCommaPrice((detailData?.contract?.collect_type == 'l' ? detailData?.qty_l : detailData?.qty_kg) || 0)}</td>
                </tr>
                <tr>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">총 수거 금액</td>
                  <td colSpan={3} className="w-85">{Util.setCommaPrice(detailData?.total_price || 0)}</td>
                </tr>
              </tbody>
            </table>
            <div className="mb-2 margin-top-40">
              <p className="mb-0 font-size-12"><span className="font-size-13">거래처 수거 목록</span> [ 건수 : {detailDataList.length}건 ]</p>
            </div>
            <div className="table-responsive">
              <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
                <thead className="chart-thead">
                  <tr>
                    {/* <th scope="col"><input className="is-untouched is-pristine av-valid form-check-input form-check-input-custom" checked={selectedId.length === detailDataList.length} value={""} type="checkbox" onChange={() => {
                      checkAll()
                    }} /></th> */}
                    <th scope="col">No</th>
                    <th scope="col">수거일자</th>
                    <th scope="col">단가</th>
                    <th scope="col">수거량</th>
                    <th scope="col">수거금액</th>
                  </tr>
                </thead>
                <tbody className="chart-tbody">
                  {detailDataList.map((item, index) => {
                    return (
                      <tr key={'collection_settlement_edit_'+index}>
                        {/* <td><input className="is-untouched is-pristine av-valid form-check-input form-check-input-custom pointer" type="checkbox" checked={selectedId.includes(item.id)} value={item.id} onChange={() => {
                          checkList(item.id)
                        }}/></td> */}
                        <td>{detailDataList.length - index}</td>
                        <td>{item.collect_date}</td>
                        <td>{item.price_per}</td>
                        <td>{item.qty}</td>
                        <td>{item.total_price}</td>
                      </tr>
                    )
                  })}
                  {detailDataList.length === 0 &&
                    <tr>
                      <td scope="row" colSpan="14">데이터가 없습니다.</td>
                    </tr>
                  }

                </tbody>
              </table>
            </div>
            {/* <table className="input-table margin-top-14">
              <tbody>
                <tr>
                  <td className="w-15 padding-left-8 primary-bg white-text">● 정산 메모</td>
                  <td className="w-85 pb-0">
                    <textarea className="waver-text-box w-100 font-size-12 border-radius-0" placeholder="정산 메모" value={memo}
                    onChange={(e)=>{
                      setMemo(e.target.value)
                    }} />
                  </td>
                </tr>
              </tbody>
            </table> */}
          </Fragment>
        }
        footerChildren={
        <div className="d-flex justify-content-between w-100 align-items-center">
          <p style={{color: '#A92323'}} className="mb-0 font-size-12"></p>
          <div className="d-flex">
            {/* <button style={{width: 112, height: 27}} className="`custom-btn border-radius-0 margin-right-4 font-size-11 line-height-1 error-bg white-text border-none" onClick={() => {
              modalOpen('deactivate')
            }}>정산 금액 제외</button> */}
            <button style={{width: 59, height: 27}} className="custom-btn border-radius-0 font-size-11 line-height-1 button-border secondary-text white-bg margin-right-0" onClick={() => {
              setSelectedItem(null)
              modalClose('edit')
            }}>취소</button>
          </div>
        </div>
        }
      />

      <Modal
        title={'정산 금액 제외'}
        show={modalShow.deactivate}
        onHide={() => {
          modalClose('deactivate')
        }}
        size="md"
        bodyChildren={
          <Fragment>
            <p>정산 금액 제외 시 "월 정산" 에서 수거금액이 0으로<br/>표시 되어 정산 금액이 줄어들 수 있습니다.</p>
            <p className="mb-0">정말 정산 금액을 제외 하시겠습니까?</p>
          </Fragment>
        }
        footerChildren={
        <div className="d-flex justify-content-end">
          <button style={{width: 'auto'}} type="button" className="waves-effect custom-btn active btn btn-dark-gradient btn-sm" onClick={() => {
            deleteSettlement()
          }}>
            확인
          </button>
          <button style={{width: 'auto'}} type="button" className="waves-effect custom-btn active btn btn-white-border btn-sm" onClick={() => {
            modalClose('deactivate')
          }}>
            취소
          </button>
        </div>
        }
      >
      </Modal>
    </Fragment>
  )
}

export default CollectionSettlementTable
